module.exports = __webpack_public_path__ + "img/start-tour-background.214a5dfb.png";